import type { AuditItem, AuditState, MutationClass } from '../../../models'

export class SetDataMutation implements MutationClass {
  static execute(this: void, state: AuditState, data: AuditItem[]): void {
    state.data = data
  }
}
